import React from 'react'
import { Table } from 'react-bootstrap'

const BusinessSettingsComponent = ({ data }) => (
  <div className='ibox float-e-margins animated fadeIn section-shadow'>
    <div className='ibox-title round-corner-box-top'>
      <h5>Business Settings</h5>
    </div>
    <div className='ibox-content round-corner-box-bottom'>
      {data && data.length ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Authentication Scheme</th>
              <th>Expected Status</th>
              <th>Retry Limit</th>
              <th>Callback Url</th>
              <th>Callback Enabled</th>
              <th>Callback Paused</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s, i) => (
              <tr key={i}>
                <td>{s.id}</td>
                <td>{s.callback_authentication_scheme}</td>
                <td>{s.callback_expected_status}</td>
                <td>{s.callback_retry_limit}</td>
                <td>{s.callback_url || 'N/A'}</td>
                <td>{s.is_callback_enabled ? <i className='fa fa-check' /> : <i className='fa fa-minus' />}</td>
                <td>{s.is_callback_paused ? <i className='fa fa-check' /> : <i className='fa fa-minus' />}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <span>{'N/A'}</span>
      )}
    </div>
  </div>
)
export default BusinessSettingsComponent
